module.exports = [{
      plugin: require('/builds/waglabs/wagtag-web/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-56VTZ9Q","includeInDevelopment":false},
    },{
      plugin: require('/builds/waglabs/wagtag-web/node_modules/gatsby-plugin-rollbar/gatsby-browser.js'),
      options: {"plugins":[],"accessToken":"e444128297e5475180160ee0ef6bd9a2","captureUncaught":true,"captureUnhandledRejections":true,"payload":{"environment":"production"},"bucketName":"wagtag.wag-prod01.net"},
    },{
      plugin: require('/builds/waglabs/wagtag-web/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-62574353-1","head":true},
    },{
      plugin: require('/builds/waglabs/wagtag-web/node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"x1PQ2SeaYtInyi8LQXwKjodcp5BW46N7","trackPage":true},
    },{
      plugin: require('/builds/waglabs/wagtag-web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
